import { render } from "./IndexView.vue?vue&type=template&id=0fc0101e&scoped=true"
const script = {}

import "./IndexView.vue?vue&type=style&index=0&id=0fc0101e&lang=scss&scoped=true"

import exportComponent from "/Users/huangmaobin/Desktop/test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc0101e"]])

export default __exports__